import { useMemo, useState } from 'react';
import { Autocomplete } from '@mui/material';
import { useLookupCustomer, useLookupText } from '@shared/hooks';
import { Input } from '@shared/widgets';

interface CustomerOption {
  label: string;
  value: string;
}

interface CustomerInputProps {
  name: string;
  label: string;
  value: string;
  error?: boolean;
  helperText?: string;
  onChange: (value: string) => void;
}

export const CustomerInput = (props: CustomerInputProps) => {
  const [text, setText] = useState<string>('');

  const { customers, loading } = useLookupCustomer(text);
  const { customers: valueCustomers, loading: valueLoading } = useLookupText(props.value, text);

  const options = useMemo(() => {
    const result: CustomerOption[] = [];
    const index: Record<string, boolean> = {};

    (valueCustomers || []).forEach((customer) => {
      const item = {
        label: customer.customer.fullname,
        value: (customer.customer.custCode || '').trim(),
      };
      if (!index[item.value]) {
        index[item.value] = true;
        result.push(item);
      }
    });

    (customers || []).forEach((customer) => {
      const item = {
        label: customer.customer.fullname,
        value: (customer.customer.custCode || '').trim(),
      };
      if (!index[item.value]) {
        index[item.value] = true;
        result.push(item);
      }
    });

    return result;
  }, [customers, valueCustomers]);

  const inputText = text || valueCustomers?.[0]?.customer?.fullname || '';

  return (
    <Autocomplete<CustomerOption, false, false, false>
      options={options}
      getOptionLabel={(option) => option.label || ''}
      isOptionEqualToValue={(option, selectedValue) => option.value === selectedValue.value}
      onChange={(_, selectedOption) => {
        if (selectedOption) {
          props.onChange?.(selectedOption.value);
          setText(selectedOption.label);
        } else {
          props.onChange?.('');
          setText('');
        }
      }}
      inputValue={inputText}
      onInputChange={(_, newInputValue) => setText(newInputValue)}
      value={options.find((opt) => opt.value === props.value) || null}
      loading={loading || valueLoading}
      renderInput={(params) => (
        <Input
          {...params}
          name={props.name}
          label={props.label}
          placeholder='Type to select'
          required
          error={props.error}
          helperText={props.helperText}
          onChange={(e) => setText(e.target.value)}
        />
      )}
    />
  );
};
